import React from 'react';
import { TextField } from '@mui/material';
import { useAppSelector, useAppDispatch } from '../../../../../app/store';
import { updateCheckInfoAction as updateCheckInfo } from '../../../../../services/RefundService/slice';

export const AddressLine2Field: React.FC = () => {
    const dispatch = useAppDispatch();
    const { currentRefund } = useAppSelector(state => state.refund);

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        dispatch(updateCheckInfo({ streetAddress2: event.target.value }));
    };

    return (
        <TextField
            label="Address Line 2"
            value={currentRefund?.checkInfo?.streetAddress2 || ''}
            onChange={handleChange}
            size="small"
            sx={{ flex: 2 }}
        />
    );
};

export default AddressLine2Field;
